import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-circleFinishInverse",
  "use": "icon-circleFinishInverse-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-circleFinishInverse\"><defs><style type=\"text/css\"></style></defs><path d=\"M512.064 0C229.248 0 0 229.216 0 512s229.248 512 512.032 512S1024.096 794.784 1024.096 512 794.848 0 512.064 0zM513.824 683.136l-71.296 76.736L153.376 491.296l71.296-76.736 216.8 201.344L798.432 231.52l72.384 67.232L513.824 683.136 513.824 683.136z\" p-id=\"907\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/circleFinishInverse.svg
// module id = Ckgy
// module chunks = 25